export default "/build/images/dinersclub.f7c39816.png";